import ErrorFallBack from "./ErrorFallBack";

export default ErrorFallBack;
